/* eslint-disable camelcase */
/* eslint-disable complexity */
import { history as historyRouter } from 'instantsearch.js/es/lib/routers';

import {
  getUrlParameters,
  getCityQueryAndState,
  getRouteStateDefaultValues,
  jobFiltersRouteMappings,
  parseURLToState,
  routeToState,
  getCityStateUsingSplitQuery,
  isZipCodeSearch,
} from './utils';

const router = params =>
  historyRouter({
    windowTitle({ query }) {
      const urlParameters = getUrlParameters();
      const { page } = urlParameters;
      if (query && page !== 'companies') {
        const { cityQuery, state } = getCityQueryAndState(query);
        let windowTitle = '';

        if (state) {
          windowTitle = `Find CDL Job Now Jobs near You in ${state}`;
        }

        if (cityQuery) {
          windowTitle = `CDL ${
            page === 'jobs' ? 'Job Now' : 'Truck Driver'
          } Jobs near ${query}`;
        }

        if (query && cityQuery === '' && state === '') {
          windowTitle = `Find CDL Job Now Jobs near You in ${query}`;
        }

        return windowTitle
          ? [windowTitle, 'Trucking Job'].filter(Boolean).join(' - ')
          : params['job_meta_title'] ??
              'Truck Driver Job Listings - Search for Your Trucking Job';
      }
    },

    createURL({ qsModule, routeState }) {
      const urlParameters = getUrlParameters();
      const { baseUrl, hash } = urlParameters;
      let page = urlParameters.page;
      const queryParameters = {};
      const routeStateDefaultValues = getRouteStateDefaultValues(params);

      if (
        (page !== 'locations' || isZipCodeSearch(routeState.query)) &&
        routeState.query &&
        routeState.query !== routeStateDefaultValues.query
      ) {
        queryParameters.query = encodeURIComponent(routeState.query);
      }

      if (page !== 'companies') {
        params['job_filters'].forEach(filter => {
          if (
            routeState[filter] &&
            routeState[filter] !== routeStateDefaultValues[filter]
          ) {
            queryParameters[filter] = routeState[filter].map(encodeURIComponent);
          }
        });
      }

      const eauth = new URL(location).searchParams.get('eauth');
      if (eauth) {
        queryParameters['eauth'] = eauth;
      }

      const pathParameters = [];

      if (page === 'locations') {
        if (routeState.query) {
          const queryParams = getCityStateUsingSplitQuery(routeState.query);
          if (queryParams && queryParams['state']) {
            pathParameters.push(queryParams['state']);
          }
          if (queryParams && queryParams['city']) {
            pathParameters.push(queryParams['city']);
          }
          if (isZipCodeSearch(routeState.query)){
            page = 'jobs';
          }
        }
      }

      const queryString = qsModule.stringify(queryParameters, {
        addQueryPrefix: true,
        arrayFormat: 'repeat',
      });
      return `${baseUrl}${page}/${pathParameters.join('/')}${queryString}${hash}`;
    },

    parseURL({ qsModule, location }) {
      const queryParameters = qsModule.parse(location.search.slice(1));
      return parseURLToState(queryParameters, params);
    },
  });

const getStateMapping = ({ indexName, params }) => ({
  stateToRoute(uiState) {
    const indexUiState = uiState[indexName];
    const filtersStateValues = {};
    if (indexName === params['indexes']['job']) {
      params['job_filters'].forEach(filter => {
        filtersStateValues[filter] =
          indexUiState.refinementList?.[
          jobFiltersRouteMappings[filter] ?? filter
            ];
      });
    }

    return {
      query: indexUiState.query,
      ...filtersStateValues,
    };
  },

  routeToState(routeState) {
    return routeToState(indexName, routeState, params);
  },
});

const getRouting = ({ indexName, params }) => ({
  router: router(params),
  stateMapping: getStateMapping({ indexName, params }),
});

export default getRouting;
